import BenchlingConfig from 'BenchlingConfig';
import {PublishingStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {InaccessibleInfoGraphQL} from '../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

interface SchemaWithExecutionTemplate {
  __typename: 'ProcessTaskSchemaNode';
  id: string;
  entryTemplate: {
    __typename: 'TemplateNode';
    id: string;
    currentPublishingRecord:
      | {
          __typename: 'PublishingRecordNode';
          id: string;
          publishingStatus: PublishingStatus;
        }
      | InaccessibleInfoGraphQL
      | null;
  } | null;
}

export default function isSchemaExecutionTemplateUnpublished(schema: SchemaWithExecutionTemplate): boolean {
  if (!BenchlingConfig.ELN_ENABLE_TEMPLATE_PUBLISHING) {
    return false;
  } else if (schema.entryTemplate == null) {
    return false;
  } else if (schema.entryTemplate.currentPublishingRecord == null) {
    return true;
  } else if (isInaccessible(schema.entryTemplate.currentPublishingRecord)) {
    return false;
  }

  return schema.entryTemplate.currentPublishingRecord.publishingStatus !== PublishingStatus.EFFECTIVE;
}
